module.exports = __webpack_public_path__ + "static/media/cockfight.6c0f0953.webp";